import { SearchBar } from '@/components/Common';
import { Header } from '@/components/Layout/Header/Header';
import { TopicsList } from '@/components/Views';
import AddNewTips from './AddNewTips';
import TipFilter from './TipFilter';
import { TipsForm } from './TipsForm';
import { TipsList } from './TipsList';
import { useTipsList } from './TipsList.hook';

export const Tips = () => {
  const {
    selectedTip,
    setSelectedTip,
    isOpenModal,
    setIsOpenModal,
    tipsCategories,
  } = useTipsList();
  return (
    <div className="flex flex-col max-h-screen">
      <Header title="Astuces" userName="Mas Aly" role="Admin" />
      <div className="grid grid-cols-[25%_auto] items-start">
        <div className="pt-5 flex flex-col gap-10 h-[calc(100vh_-_110px)] overflow-hidden">
          <SearchBar placeholder="Mot clé" />
          <TopicsList
            showBtn={true}
            items={tipsCategories || []}
            onItemClick={(item) => setSelectedTip(item)}
            selectedItemId={selectedTip?._id}
            btnTitle="Ajouter une catégorie"
            onAddClick={() => setIsOpenModal(true)}
          />
        </div>
        <div className="flex flex-col gap-2 pl-10 pr-4 pt-3 h-[calc(100vh_-_110px)] overflow-hidden">
          <TipFilter />
          <TipsList />
          <AddNewTips />
          <TipsForm />
        </div>
      </div>
    </div>
  );
};
